module.exports = XLSX;


//////////////////
// WEBPACK FOOTER
// external "XLSX"
// module id = 1728
// module chunks = 7